export class ControlViolations {
    'high';
    'medium';
    'low';
    'muted';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "high",
            "baseName": "high",
            "type": "number",
            "format": ""
        },
        {
            "name": "medium",
            "baseName": "medium",
            "type": "number",
            "format": ""
        },
        {
            "name": "low",
            "baseName": "low",
            "type": "number",
            "format": ""
        },
        {
            "name": "muted",
            "baseName": "muted",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlViolations.attributeTypeMap;
    }
    constructor() {
    }
}
